
import { isString, map, each, filter } from 'lodash';
import { User } from '../user/user';
import { Record, RecordField } from '../record/record';
import { Dossier } from '../dossier/dossier';
import { Link } from '../dossier/link';

export class RecordLink implements Link {
  id: string
  name: string
  group_id: string = null
  record: Record
  dossier: Dossier
  fields: RecordField[] = []

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  version: number

  __typename: string

  // View model fields
  model: any  

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.record) {
      this.record = new Record(this.record);
    }

    if(this.dossier) {
      this.dossier = new Dossier(this.dossier);
    }

    if(this.fields) {
      this.fields = map(this.fields, f => new RecordField(f));
    }
  }

  replaceWith(replacement: RecordLink) {
    Object.assign(this, replacement);
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 200) {
      return false;
    }

    if(trimmedName.length === 0) {
      return false;
    }

    // fields
    let fieldsValid = true;

    each(this.fields , field => {
      if(!field.valid) {
        fieldsValid = false;
      }
    });

    if(!fieldsValid) {
      return false;
    }

    return this.record.valid;
  }

  /**
   * Returns the list of fields allowed by the model
   */
  get modelFields() {
    if(!this.model) {
      return [];
    }

    return filter(this.fields, field => {
      return this.model.fields[field.name] !== undefined;
    });
  }

  toLinkNewRecordInput(dossier_id: string) {
    return {
      dossier_id,
      name: this.name,
      group_id: this.group_id,
      fields: map(this.modelFields, f => f.toRecordFieldInput()),
      record: this.record.toCreateRecordInput()
    };
  }

  toLinkExistingRecordInput(dossier_id: string, record_id: string) {
    return {
      dossier_id,
      record_id,
      name: this.name,
      group_id: this.group_id,
      fields: map(this.modelFields, f => f.toRecordFieldInput()),
      record: this.record.toUpdateRecordInput()
    };
  }

  toUpdateRecordLinkInput() {
    return {
      version: this.version,
      fields: map(this.modelFields, f => f.toRecordFieldInput()),
      record: this.record.toUpdateRecordInput()
    };
  }

  /**
   * Link interface
   */
  isRecordLink(): boolean {
    return true;
  }

  isDataLink(): boolean {
    return false;
  }
}
